// extracted by mini-css-extract-plugin
module.exports = {"moreAction":"_2v3P_","box":"_1Wzqc"};